import React, { useContext } from 'react';

import { Icon } from '@ontruck/orc';

import BiddingList from 'modules/bidding/list';
import BiddingContext from 'modules/bidding/context';

const t = {
  active_bids: 'Active bids',
  rejected_bids: 'Cancelled bids',
};

const BiddingSection = ({ className }) => {
  const { close, isOpened } = useContext(BiddingContext);

  if (!isOpened) {
    return null;
  }

  return (
    <div className={className} data-testid="bidding-section">
      <div className="toolbar">
        <button className="close" onClick={close}>
          <Icon glyph="close" size="1.6rem" color="white" />
        </button>
      </div>
      <div className="header">{t.active_bids}</div>
      <BiddingList />
      <div className="header">{t.rejected_bids}</div>
      <BiddingList showRejected={true} />
    </div>
  );
};

export default BiddingSection;
